import { useIntl } from 'react-intl';

import { getActionAriaLabelSync } from '@/utils/ariaLabels';

import * as M from '@/messages/common';
import { useRegionProvider } from '@/providers/RegionProvider';

import * as S from './CardRichTextRenderer.styles';
export const ShowMore = ({
  enableShowMore,
  isExpanded,
  setIsExpanded,
  showMoreType,
}: {
  enableShowMore: boolean;
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  showMoreType: string;
}) => {
  const { formatMessage } = useIntl();
  const { locale } = useRegionProvider();
  if (!enableShowMore) return null;

  if (showMoreType === 'icon') {
    return isExpanded ? (
      <S.ShowLessIcon
        aria-label={
          getActionAriaLabelSync('show_less', locale.code) || 'Show less'
        }
        data-test-id='icon-show-less'
        onClick={() => setIsExpanded(false)}
        role='button'
      />
    ) : (
      <S.ShowMoreIcon
        aria-label={
          getActionAriaLabelSync('show_more', locale.code) || 'Show more'
        }
        data-test-id='icon-show-more'
        onClick={() => setIsExpanded(true)}
        role='button'
      />
    );
  }

  return (
    <S.ToggleButton
      data-testid='content-toggle-button'
      onClick={() => setIsExpanded(!isExpanded)}
      variant='link'
    >
      {isExpanded
        ? formatMessage(M.commonMessages.showLess)
        : formatMessage(M.commonMessages.showMore)}
    </S.ToggleButton>
  );
};
